export default "__VITE_ASSET__c9is1UX3__"